<app-base-widget data-cy="geographyWidget">
    <div header class="card-header flex border-b border-light-grey p-3"> Geography
        <div>
            <app-info-icon tooltipPosition="above" tooltipInfo="Primary region in which underlying assets operate"
                data-cy="geographyTooltip" tooltipClass="mt-[3px]">
            </app-info-icon>
        </div>
    </div>
    <app-base-geography-widget [byText]="byText" [widgets]="widgets()" [currency]="currency() ?? 'USD'" [showUSMapWidget]="showUSMapWidget()" [otherCountryNames]="otherCountryNames()"></app-base-geography-widget>
</app-base-widget>